export const registerUser = gql`
    mutation registerUser(
        $input: RegisterInput!
    ) {
        register(
            input: $input
        ) {
            status
        }
    }
`
